import React, { FC, useEffect, useState } from "react";
import "moment/locale/id";
import "./homePage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import clock from "../../assets/svg/clock.svg";
import patrol from "../../assets/svg/speaker.svg";
import BeforeAbsence from "../beforeAbsenceComponent/beforeAbsenceComponent";
import { get } from "http";
import { HttpGet } from "../../providers/HttpClient";
import iconPatrol from "../../assets/icons8-patrol-64.png";
import iconOvertime from "../../assets/icons8-overtime-64.png";
import iconBackup from "../../assets/icons8-work-64.png";
import iconLog from "../../assets/log-file.png";
import payrollIcon from "../../assets/payroll.png";

interface CheckMenuProps {
  isAbsence: boolean;
}
const Menus: FC<CheckMenuProps> = (props): JSX.Element => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menus, setMenus] = useState<any[]>([]);
  const [companyProfile, setCompanyProfile] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")),
  );
  const [allowCheckPointPatrol, setAllowCheckPointPatrol] = useState(false);

  const closeAction = async () => {
    setOpen(false);
  };

  const getCompanySetting = async () => {
    HttpGet("member/company/setting").then((res: any) => {
      if (res.data) {
        setAllowCheckPointPatrol(res.data.allowCheckPointPatrol);
      }
    });
  };

  useEffect(() => {
    HttpGet("member/menu").then((res: any) => {
      setMenus(res.data);
    });
    getCompanySetting();
  }, []);
  return (
    <>
      <BeforeAbsence isOpen={open} closeAction={closeAction} />
      <div className="flex justify-around rounded-2xl w-full bg-white p-3 shadow-md mb-4">
        {menus.map((prop, index) => {
          return (
            <div key={index} className="grid">
              <div
                onClick={() => {
                  if (prop.key === "OVERTIME") {
                    navigate("/home/overtimes-list");
                  } else if (prop.key === "PAYROLL") {
                    navigate("/home/payroll");
                  } else {
                    props.isAbsence != null
                      ? navigate(
                          prop.key === "OVERTIME_BACKUP"
                            ? "/home/overtime-form"
                            : prop.key === "WORK_ACTIVITIES" &&
                                allowCheckPointPatrol
                              ? "/home/patrol-qrcode"
                              : prop.key === "WORK_ACTIVITIES" &&
                                  !allowCheckPointPatrol
                                ? "/home/patrol-form"
                                : prop.key === "OVERTIME"
                                  ? "/home/overtimes-list"
                                  : prop.key === "LOG_BOOK"
                                    ? "/home/log-book-list"
                                    : "",
                        )
                      : setOpen(true);
                  }
                }}
                // style={prop.key != "OVERTIME_BACKUP" ? { height: 9 } : {}}
                className="w-fit rounded-md bg-white justify-self-center "
              >
                {/* <FontAwesomeIcon
                  className=" text-slate-600"
                  size="lg"
                  // color={companyProfile.color}
                  icon={
                    prop.key === "OVERTIME"
                      ? "business-time"
                      : prop.key === "OVERTIME_BACKUP"
                      ? "user-clock"
                      : prop.key === "WORK_ACTIVITIES"
                      ? "bullhorn"
                      : "triangle-exclamation"
                  }
                /> */}
                <img
                  src={
                    prop.key === "OVERTIME"
                      ? iconOvertime
                      : prop.key === "OVERTIME_BACKUP"
                        ? iconBackup
                        : prop.key === "WORK_ACTIVITIES"
                          ? iconPatrol
                          : prop.key === "LOG_BOOK"
                            ? iconLog
                            : prop.key === "PAYROLL"
                              ? payrollIcon
                              : null
                  }
                  alt="qr"
                  className="p-2 image-menu"
                />
              </div>
              <p className="text-slate-700 text-center font-light text-xs w-14">
                {prop.readableName}
              </p>
            </div>
          );
        })}

        {/* <div>
          <div
            onClick={() => {
              props.isAbsence != null
                ? navigate("/home/patrol-form")
                : setOpen(true);
            }}
            className="w-fit rounded-md bg-white "
          >
            <img src={patrol} alt="qr" className="p-2 image-menu" />
          </div>
          <p className="text-black text-center font-light text-sm">Patroli</p>
        </div> */}
      </div>
    </>
  );
};

export default Menus;
